import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ResizableModule } from 'angular-resizable-element';

import { IconModule } from 'shared/icon/icon.module';
import { AppTooltipModule } from 'shared/tooltip/tooltip.module';

import { SideDrawerComponent } from './sidedrawer.component';
import { SideDrawerService } from './sidedrawer.service';
import { SideDrawerResponsiveDirective } from './sidedrawer-responsive.directive';


@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    ResizableModule,
    IconModule,
    AppTooltipModule,
  ],
  declarations: [
    SideDrawerResponsiveDirective,
    SideDrawerComponent,
  ],
  exports: [
    SideDrawerComponent,
    SideDrawerResponsiveDirective,
  ],
  providers: [ SideDrawerService ],
})
export class SideDrawerModule {}
